import React from 'react'
import Navbar from '../HomeComponents/Navbar';
import Footer from '../HomeComponents/Footer';
import './CourseStyle.css'
import Maths from './Maths.png'
import Physics from './Physics.png'
import Chemistry from './Chemistry.png'
import Economics from './Economics.png'
import Business from './Business.png'
import History from './History.png'

export default function CourseHomeM() {
    return (
        <>
            <Navbar />
            <div className="MainContainer">
                <p id='course-tagline'>Top Quality Courses</p>
            </div>


            <section class="text-gray-600 body-font">
                <div class="container px-5 py-24 mx-auto">
                    <div class="flex flex-wrap -m-4">
                        <div class="p-4 md:w-1/3">
                            <div class="h-full border-2 border-gray-200 border-opacity-60 rounded-lg overflow-hidden">
                                <img class="lg:h-48 md:h-36 w-full object-cover object-center" src={Maths} alt="blog" />
                                <div class="p-6">
                                    <h2 class="tracking-widest text-xs title-font font-medium text-gray-400 mb-1 urbanist">COURSES</h2>
                                    <h1 class="title-font text-lg font-medium text-gray-900 mb-3 urbanist"> Physics + Chemistry +Maths (PCM)
                                    </h1>
                                    <p class="leading-relaxed mb-3">Faculty (Yashpal Sir For P & M, Sandeep Sir For C) <br />
                                        Starts 6 April 2024 <br />
                                        Till Last Board 2025 <br />
                                        Included weekly tests and Reports <br />
                                        Personlised Material
                                    </p>
                                    <div class="flex flex-col">

                                        <div class="text-gray-700 flex items-center leading-none text- my-4 urbanist-bold">
                                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6 mr-1">
                                                <path strokeLinecap="round" strokeLinejoin="round" d="M15 8.25H9m6 3H9m3 6l-3-3h1.5a3 3 0 100-6M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                                            </svg>Complete Course Fee (Rs.27,999)

                                        </div>
                                    </div>

                                    <button className="fancy mb-5" id="">
                                        <span className="top-key"></span>
                                        <span className="text">Join Now</span>
                                        <span className="bottom-key-1"></span>
                                        <span className="bottom-key-2"></span>
                                    </button>


                                </div>
                            </div>
                        </div>
                        <div class="p-4 md:w-1/3">
                            <div class="h-full border-2 border-gray-200 border-opacity-60 rounded-lg overflow-hidden">
                                <img class="lg:h-48 md:h-36 w-full object-cover object-center" src={Physics} alt="blog" />
                                <div class="p-6">
                                    <h2 class="tracking-widest text-xs title-font font-medium text-gray-400 mb-1">COURSES</h2>
                                    <h1 class="title-font text-lg font-medium text-gray-900 mb-3">JEE(PCM)
                                    </h1>
                                    <p class="leading-relaxed mb-3">Faculty (Yashpal Sir For P & M, Sandeep Sir For C) <br />
                                        Starts 3 March 2024 <br />
                                        Till June 2025 <br />
                                        Included biweekly tests and Reports <br />
                                        <br />
                                    </p>
                                    <div class="flex flex-col">
                                        <div class="text-gray-700 flex items-center leading-none my-4 urbanist-bold">
                                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
                                                <path strokeLinecap="round" strokeLinejoin="round" d="M15 8.25H9m6 3H9m3 6l-3-3h1.5a3 3 0 100-6M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                                            </svg>Complete Course Fee (Rs.34,999)

                                        </div>
                                    </div>

                                    <button className="fancy" id="">
                                        <span className="top-key"></span>
                                        <span className="text">Join Now</span>
                                        <span className="bottom-key-1"></span>
                                        <span className="bottom-key-2"></span>
                                    </button>




                                </div>
                            </div>
                        </div>
                        <div class="p-4 md:w-1/3">
                            <div class="h-full border-2 border-gray-200 border-opacity-60 rounded-lg overflow-hidden">
                                <img class="lg:h-48 md:h-36 w-full object-cover object-center" src={Chemistry} alt="blog" />
                                <div class="p-6">
                                    <h2 class="tracking-widest text-xs title-font font-medium text-gray-400 mb-1">COURSES</h2>
                                    <h1 class="title-font text-lg font-medium text-gray-900 mb-3">Applied Maths(Class 11-12)
                                    </h1>
                                    <p class="leading-relaxed mb-3">Faculty (Yashpal Sir)<br />
                                        Starts 8 April 2024 <br />
                                        Till Last Board 2025 <br />
                                        Included weekly tests and Reports<br />
                                        <br />
                                        <br />
                                    </p>
                                    <div class="flex flex-col">
                                        <div class="text-gray-700 flex items-center leading-none my-4 urbanist-bold">
                                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
                                                <path strokeLinecap="round" strokeLinejoin="round" d="M15 8.25H9m6 3H9m3 6l-3-3h1.5a3 3 0 100-6M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                                            </svg>Complete Course Fee (Rs.12,999)

                                        </div>
                                    </div>


                                    <button className="fancy" id="btnn">
                                        <span className="top-key"></span>
                                        <span className="text">Join Now</span>
                                        <span className="bottom-key-1"></span>
                                        <span className="bottom-key-2"></span>
                                    </button>




                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


            <div class="container px-5 mx-auto">
                <div class="flex flex-wrap -m-4">
                    <div class="p-4 md:w-1/3">
                        <div class="h-full border-2 border-gray-200 border-opacity-60 rounded-lg overflow-hidden">
                            <img class="lg:h-48 md:h-36 w-full object-cover object-center" src={Business} alt="blog" />
                            <div class="p-6">
                                <h2 class="tracking-widest text-xs title-font font-medium text-gray-400 mb-1">COURSES</h2>
                                <h1 class="title-font text-lg font-medium text-gray-900 mb-3">Accounts + B.St. + Eco. (Class 11-12)
                                </h1>
                                <p class="leading-relaxed mb-3">Faculty (Ganesh Sir) <br />
                                    Starts 3 March 2024 <br />
                                    Till Boards 2025 <br />
                                    Included weekly tests and Reports <br />
                                    <br />
                                    <br />
                                </p>
                                <div class="flex flex-col ">


                                    <div class="text-gray-700 flex items-center leading-none my-4 urbanist-bold">
                                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
                                            <path strokeLinecap="round" strokeLinejoin="round" d="M15 8.25H9m6 3H9m3 6l-3-3h1.5a3 3 0 100-6M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                                        </svg>Complete Course Fee (Rs.27,999)

                                    </div>
                                </div>


                                <button className="fancy" id="btnn">
                                    <span className="top-key"></span>
                                    <span className="text">Join Now</span>
                                    <span className="bottom-key-1"></span>
                                    <span className="bottom-key-2"></span>
                                </button>

                            </div>
                        </div>
                    </div>
                    <div class="p-4 md:w-1/3">
                        <div class="h-full border-2 border-gray-200 border-opacity-60 rounded-lg overflow-hidden">
                            <img class="lg:h-48 md:h-36 w-full object-cover object-center" src={Economics} alt="blog" />
                            <div class="p-6">
                                <h2 class="tracking-widest text-xs title-font font-medium text-gray-400 mb-1">COURSES</h2>
                                <h1 class="title-font text-lg font-medium text-gray-900 mb-3">All Subjects(Class 1-5)
                                </h1>
                                <p class="leading-relaxed mb-3">Faculty (Anuradha Mam, Labesh Sir, Abhishek Sir) <br />
                                    Starts 14 March 2024 <br />
                                    Till March 2025 <br />
                                    Included weekly tests and Reports <br />
                                </p>
                                <div class="flex flex-col">

                                    <br />

                                    <div class="text-gray-700 flex items-center leading-none my-4 urbanist-bold">
                                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
                                            <path strokeLinecap="round" strokeLinejoin="round" d="M15 8.25H9m6 3H9m3 6l-3-3h1.5a3 3 0 100-6M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                                        </svg>
                                        Complete Course Fee (Rs.15,999)

                                    </div>
                                </div>


                                <button className="fancy" id="btnn">
                                    <span className="top-key"></span>
                                    <span className="text">Join Now</span>
                                    <span className="bottom-key-1"></span>
                                    <span className="bottom-key-2"></span>
                                </button>

                            </div>
                        </div>
                    </div>
                    <div class="p-4 md:w-1/3">
                        <div class="h-full border-2 border-gray-200 border-opacity-60 rounded-lg overflow-hidden">
                            <img class="lg:h-48 md:h-36 w-full object-cover object-center" src={History} alt="blog" />
                            <div class="p-6">
                                <h2 class="tracking-widest text-xs title-font font-medium text-gray-400 mb-1">COURSES</h2>
                                <h1 class="title-font text-lg font-medium text-gray-900 mb-3">Personalised Competitive Studies
                                </h1>
                                <p class="leading-relaxed mb-3">Based on the need of student <br />
                                    Personalised Attention <br />
                                    Custom Batch Duration <br />
                                    <br /><br />
                                    </p>
                                <div class="flex  flex-col ">
                                    <br />

                                    <div class="text-gray-700 flex items-center leading-none my-4 urbanist-bold">
                                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
                                            <path strokeLinecap="round" strokeLinejoin="round" d="M15 8.25H9m6 3H9m3 6l-3-3h1.5a3 3 0 100-6M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                                        </svg>Complete Course Fee (Rs.19,999 - Rs.29,999)

                                    </div>
                                </div>

                                <button className="fancy" id="btnn">
                                    <span className="top-key"></span>
                                    <span className="text">Join Now</span>
                                    <span className="bottom-key-1"></span>
                                    <span className="bottom-key-2"></span>
                                </button>


                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
}